/* eslint-disable react/no-danger */
import React, { useState } from 'react';
import dynamic from 'next/dynamic';
import fetch from 'isomorphic-unfetch';
import sanitizeHtml from 'sanitize-html';
import { WordPressAPI } from '../config';
import { useMediaQuery } from '@/helpers/hooks';
import validatePaidCampaign from '@helpers/validatePaidCampaign';
import SEOHead from '@components/SEOHead/SEOHead';
import Header from '@components/Header/Header';
import FooterComponent from '@components/Footer/FooterComponent';
import CCPAStyles from '@/components/CCPA/CCPAStyles';
import CCPAForm from '@/components/CCPA/CCPAForm';
import sendEmail from '@/services/sendEmail'

const FooterNewsModal = dynamic(import('@/components/FooterNewsModal'));

const sanitizeSettings = {
  allowedTags: ['p'],
};

const CCPA = ({ data }) => {
  const { acf } = data;
  const {
    meta_description,
    additional_questions,
    hero_title, hero_title_2,
    phone_number_setup,
    page_title_tag
  } = acf;
  const paid_campaign = validatePaidCampaign(acf.paid_campaign);
  const isMobile = useMediaQuery('(max-width: 992px)');
  const [currentStep, setCurrentStep] = useState(1); // 1 is form, 2 is confirmation
  const [errors, setErrors] = useState('')

  const submit = async (formData) => {
    const date = new Date().toString();
    formData.date = date;
    const res = await sendEmail(formData);
    if (res.status === 200) {
      setCurrentStep(2);
    } else {
      setErrors("error in setting email");
    }
  }

  return (
    <CCPAStyles>
      <SEOHead>
        <title>{page_title_tag}</title>
        <meta name="description" content={meta_description} key="description" />
        <script
          type="text/javascript"
          src="//app-ab33.marketo.com/js/forms2/js/forms2.min.js"
        />
      </SEOHead>
      <Header
        AdditionalQuestions={additional_questions}
        PaidCampaign={paid_campaign}
        phone_number={phone_number_setup}
        leadValues={acf.lead_values}
        hideLinks={false}
        customClass="data-removal"
      />
      {currentStep === 1 && (
        <div className="content">
          <h1 className="title">{hero_title}</h1>
          <div
            className="subtitle"
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(hero_title_2, sanitizeSettings),
            }}
          />
          {errors && (
            <div>There was an issue processing your request. Please try again or contact the phone number above</div>
          )}
          <CCPAForm onComplete={submit} />
        </div>
      )}
      {currentStep === 2 && (
        <div className="confirmation">
          <div className="title">Thank you for submitting your request.</div>
          <div className="subtitle">We will be in contact with you after we process your request.</div>
          <img className="confirmation-icon" alt="confirmation-icon" src="/icons/ccpa-orange-check.svg" />
        </div>
      )}

      {/* Email Newsletter */}
      <FooterNewsModal />
      <FooterComponent phone_number={phone_number_setup} />

    </CCPAStyles>
  );
}

export const getStaticProps = async () => {
  let pageNumber;
  if (WordPressAPI.pages.includes('marketing')) {
    pageNumber = '21024'
  } else {
    pageNumber = '21006'
  }
  const pagesRes = await fetch(`${WordPressAPI.pages}/${pageNumber}`);
  const data = await pagesRes.json();

  return {
    props: {
      data,
    },
    revalidate: 1,
  };
};

export default CCPA;